import styled from 'styled-components';

export const HeaderStyled = styled.header`
  padding: 12px 0;
  display: flex;
  justify-content: flex-end;
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  margin-bottom: 20px;
`;

export const LogoContainer = styled.div<{
  isLoaded: boolean;
}>`
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  img {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
    transition: 0.2s;
  }
`;
